// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__pqBXe","slider__video":"slider_slider__video__IQpdi","slider__photo":"slider_slider__photo__1crI2"};